import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const logoFooterTextFn = /* @__PURE__ */ createRecipe('logo-footer-text', {}, [])

const logoFooterTextVariantMap = {}

const logoFooterTextVariantKeys = Object.keys(logoFooterTextVariantMap)

export const logoFooterText = /* @__PURE__ */ Object.assign(memo(logoFooterTextFn.recipeFn), {
  __recipe__: true,
  __name__: 'logoFooterText',
  __getCompoundVariantCss__: logoFooterTextFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: logoFooterTextVariantKeys,
  variantMap: logoFooterTextVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, logoFooterTextVariantKeys)
  },
  getVariantProps: logoFooterTextFn.getVariantProps,
})